<style lang="less">
.themeleft {
  width: 100%;
  height: 100%;
  .themeleft1 {
    width: 100%;
    height: 100%;
    .themeleft_1 {
      width: 100%;
      height: 150px;
    }
    .themeleft_overy {
      width: 100%;
      height: 500px;
      overflow: hidden;
      position: relative;
      .themeleft_2 {
        width: 100%;
      }
      .themeleft_3 {
        width: 100%;
      }
      .themeleft_4 {
        height: 100%;
        width: 100%;
      }
    }

    .themeleft_5 {
      width: 100%;
    }
  }
  .left_xz {
    width: 100%;
  }
}
</style>
<template>
  <div class="themeleft media_w_w14">
    <div class="themeleft1 display_column">
      <div class="themeleft_1 dispaly_flex00">
        <research_total></research_total>
      </div>
      <div class="themeleft_overy dispaly_flex11">
        <div class="themeleft_4">
          <district_state :chartid='"district_state_echart"'></district_state>
        </div>
        <!-- <div class="media_h_left"> -->

        <!-- <div class=" themeleft_3 ">
                        <district_district :chartid='"district_district_echart"'></district_district>
        </div>-->
        <!-- </div> -->
        <!-- <div class="">
                    <div class="themeleft_4 media_h_left2">
                        <district_state :chartid='"district_state_echart2"'></district_state>
                    </div>
                    <div class=" themeleft_3 media_h_left">
                        <district_district :chartid='"district_district_echart2"'></district_district>
                    </div>
        </div>-->
      </div>
      <div class="themeleft_5 dispaly_flex00 media_h_left_5">
        <node_warning></node_warning>
      </div>
    </div>
  </div>
</template>

<script>
import research_total from "./research_total/research_total.vue"; //科研总量
// import district_district from "./district_district/district_district.vue";//科研分类
import district_state from "./district_state/district_state.vue"; //科研状态
import node_warning from "./node_warning/node_warning.vue"; //节点预警
export default {
  components: {
    research_total,
    // district_district,
    district_state,
    node_warning
  },
  data() {
    return {};
  },
  methods: {
    recordwidth: function() {
      if (document.getElementById("district_district_echart") != null) {
        this.$echarts
          .init(document.getElementById("district_district_echart"))
          .resize();
      }
      if (document.getElementById("district_state_echart") != null) {
        this.$echarts
          .init(document.getElementById("district_state_echart"))
          .resize();
      }
      if (document.getElementById("district_district_echart2") != null) {
        this.$echarts
          .init(document.getElementById("district_district_echart2"))
          .resize();
      }
      if (document.getElementById("district_state_echart2") != null) {
        this.$echarts
          .init(document.getElementById("district_state_echart2"))
          .resize();
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.recordwidth, false);
  },
  directives: {},
  beforeDestroy() {
    window.removeEventListener("resize", this.recordwidth, false);
  }
};
</script>




// WEBPACK FOOTER //
// left.vue?49a912ba